// Create the angular application
var crNgModules = ['ngResource', 'ngSanitize', 'ngCookies', 'ngAnimate', 'ngMessages', 'ngTouch' , 'ui.bootstrap', 'templates', 'PubSub'];
crNgModules = crNgModules.concat(ngModulesPage); // for each page there is an array of ng modules
crApp = angular.module(NgAppName, crNgModules);

angular.module(NgAppName).run(['$http', '$cookies',
	function($http, $cookies) {
		// For CSRF token compatibility with Yii
		var metaCRSF = document.querySelector('meta[name="csrf-token"]') ? document.querySelector('meta[name="csrf-token"]').getAttribute('content') : undefined;
		var csrfToken = metaCRSF || $cookies.get('CSRF-Token');
		$http.defaults.headers.post['X-CSRF-Token'] = csrfToken;
	}
]);
